import { useEffect, useRef } from 'react';

// Orange ink trail canvas — follows mouse cursor
export default function InkCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let points = [];
    let rafId = null;
    let lastX = 0, lastY = 0;

    const resize = () => {
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const spawnPoints = (x, y, count, baseSize, isClick) => {
      for (let i = 0; i < count; i++) {
        const angle = Math.random() * Math.PI * 2;
        const spread = isClick ? Math.random() * 12 : 0;
        points.push({
          x: x + Math.cos(angle) * spread,
          y: y + Math.sin(angle) * spread,
          vx: (Math.random() - 0.5) * (isClick ? 1.5 : 0.3),
          vy: -Math.random() * (isClick ? 2 : 0.8) - 0.2,
          size: baseSize * (0.6 + Math.random() * 0.8),
          life: 1,
          decay: isClick ? 0.018 + Math.random() * 0.012 : 0.022 + Math.random() * 0.015,
        });
      }
    };

    const onMove = (e) => {
      const dx = e.clientX - lastX;
      const dy = e.clientY - lastY;
      const speed = Math.sqrt(dx * dx + dy * dy);
      lastX = e.clientX;
      lastY = e.clientY;
      // More points when moving faster
      const count = Math.max(1, Math.floor(speed * 0.25));
      spawnPoints(e.clientX, e.clientY, count, 3 + speed * 0.06, false);
    };

    const onClick = (e) => {
      spawnPoints(e.clientX, e.clientY, 16, 7, true);
    };

    window.addEventListener('mousemove', onMove);
    window.addEventListener('click', onClick);

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      points = points.filter(p => p.life > 0);

      for (const p of points) {
        p.x  += p.vx;
        p.y  += p.vy;
        p.vx *= 0.96;
        p.vy *= 0.96;
        p.life -= p.decay;

        const alpha = Math.max(0, p.life);
        const r = Math.max(0, p.size * alpha);

        ctx.beginPath();
        ctx.arc(p.x, p.y, r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(232, 67, 10, ${alpha * 0.65})`;
        ctx.fill();
      }

      rafId = requestAnimationFrame(draw);
    };
    rafId = requestAnimationFrame(draw);

    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('click', onClick);
      window.removeEventListener('resize', resize);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100%', height: '100%',
        pointerEvents: 'none',
        zIndex: 99998,
      }}
      aria-hidden="true"
    />
  );
}
